import React from "react";
import SearchCategory from "./SearchCategory";
import DesktopSearchInput from "./DesktopSearchInput";

class DesktopSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchType: "activity"
    };
  }

  selectedCategory = category => {
    this.setState({ searchType: category });
  };
  render() {
    return (
      <div className="t-container-fluid desktop__header__search">
        <SearchCategory selectedCategory={this.selectedCategory} />
        <DesktopSearchInput category={this.state.searchType} />
      </div>
    );
  }
}

export default DesktopSearch;
